import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { useMobileMediaQuery } from 'Utils/mediaQuery';
import { Button as DesignButton, TextInput as DesignTextInput } from '@kueski-dev/kueski-ds-ui';
import { formatNumberToMX, parseMXToNumber } from 'Utils/formatters';
import styled from 'styled-components';
import '@kueski-dev/kueski-ds-ui/dist/lib/global.css';
import './designSystem.scss';

export const PlatformWrapper = ({
  mobile,
  desktop,
  children,
  mainProps,
}) => {
  const isMobile = useMobileMediaQuery();
  const Wrapper = isMobile ? mobile : desktop;

  return (
    <Wrapper {...mainProps}>
      {children}
    </Wrapper>
  );
};

PlatformWrapper.propTypes = {
  mobile: PropTypes.elementType.isRequired,
  desktop: PropTypes.elementType.isRequired,
  children: PropTypes.node,
  mainProps: PropTypes.oneOfType([PropTypes.object]),
};

PlatformWrapper.defaultProps = {
  mainProps: null,
  children: null,
};

/* TODO: Evaluate move components to design system */
export const TextPropType = PropTypes.shape({
  children: PropTypes.node.isRequired,
  colorClassName: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
});

export const textDefaultProps = {
  colorClassName: 'k-ds-text-color-primary',
  className: '',
  style: {},
};

export const TextLabel01 = ({
  children, style, colorClassName, className,
}) => (
  <p
    className={`k-ds-label-01 m-0 ${colorClassName} ${className}`}
    style={{ ...style }}
  >
    {children}
  </p>
);

TextLabel01.propTypes = TextPropType.isRequired;
TextLabel01.defaultProps = textDefaultProps;

export const TextCaption01 = ({
  children, style, colorClassName, className,
}) => (
  <p
    className={`k-ds-caption-01 m-0 ${className} ${colorClassName}`}
    style={{ ...style }}
  >
    {children}
  </p>
);

TextCaption01.propTypes = TextPropType.isRequired;
TextCaption01.defaultProps = textDefaultProps;

export const TextConsole01 = ({
  children, style, colorClassName, className,
}) => (
  <p
    className={`k-ds-console-01 m-0 ${className} ${colorClassName}`}
    style={{ ...style }}
  >
    {children}
  </p>
);

TextConsole01.propTypes = TextPropType.isRequired;
TextConsole01.defaultProps = textDefaultProps;

export const TextBody01 = ({
  children, style, colorClassName, className,
}) => (
  <p
    className={`k-ds-body-01 m-0 ${className} ${colorClassName}`}
    style={{ ...style }}
  >
    {children}
  </p>
);

TextBody01.propTypes = TextPropType.isRequired;
TextBody01.defaultProps = textDefaultProps;

export const TextBody02 = ({
  children, style, colorClassName, className,
}) => (
  <p
    className={`k-ds-body-02 m-0 ${className} ${colorClassName}`}
    style={{ ...style }}
  >
    {children}
  </p>
);

TextBody02.propTypes = TextPropType.isRequired;
TextBody02.defaultProps = textDefaultProps;

export const TextHeading01 = ({
  children,
  style,
  colorClassName,
  className,
}) => (
  <p
    className={`k-ds-heading-01 m-0 ${className} ${colorClassName}`}
    style={{ ...style }}
  >
    {children}
  </p>
);

TextHeading01.propTypes = TextPropType.isRequired;
TextHeading01.defaultProps = textDefaultProps;

export const TextHeading02 = ({
  children,
  style,
  colorClassName,
  className,
}) => (
  <p
    className={`k-ds-heading-02 m-0 ${className} ${colorClassName}`}
    style={{ ...style }}
  >
    {children}
  </p>
);

TextHeading02.propTypes = TextPropType.isRequired;
TextHeading02.defaultProps = textDefaultProps;

export const TextHeading03 = ({
  children,
  style,
  colorClassName,
  className,
}) => (
  <p
    className={`k-ds-heading-03 m-0 ${className} ${colorClassName}`}
    style={{ ...style }}
  >
    {children}
  </p>
);

TextHeading03.propTypes = TextPropType.isRequired;
TextHeading03.defaultProps = textDefaultProps;

export const TextHeading04 = ({
  children,
  style,
  colorClassName,
  className,
}) => (
  <p
    className={`k-ds-heading-04 m-0 ${className} ${colorClassName}`}
    style={{ ...style }}
  >
    {children}
  </p>
);

TextHeading04.propTypes = TextPropType.isRequired;
TextHeading04.defaultProps = textDefaultProps;

export const TextHeading05 = ({
  children,
  style,
  colorClassName,
  className,
}) => (
  <p
    className={`k-ds-heading-05 m-0 ${className} ${colorClassName}`}
    style={{ ...style }}
  >
    {children}
  </p>
);

TextHeading05.propTypes = TextPropType.isRequired;
TextHeading05.defaultProps = textDefaultProps;

export const TextHeading07 = ({
  children,
  style,
  colorClassName,
  className,
}) => (
  <p
    className={`k-ds-heading-07 m-0 ${className} ${colorClassName}`}
    style={{ ...style }}
  >
    {children}
  </p>
);

TextHeading07.propTypes = TextPropType.isRequired;
TextHeading07.defaultProps = textDefaultProps;

export const TextSubHeading01 = ({
  children,
  style,
  colorClassName,
  className,
}) => (
  <p
    className={`k-ds-subheading-01 m-0 ${className} ${colorClassName}`}
    style={{ ...style }}
  >
    {children}
  </p>
);

TextSubHeading01.propTypes = TextPropType.isRequired;
TextSubHeading01.defaultProps = textDefaultProps;

export const TextSubHeading02 = ({
  children,
  style,
  colorClassName,
  className,
}) => (
  <p
    className={`k-ds-subheading-02 m-0 ${className} ${colorClassName}`}
    style={{ ...style }}
  >
    {children}
  </p>
);

TextSubHeading02.propTypes = TextPropType.isRequired;
TextSubHeading02.defaultProps = textDefaultProps;

export const TextSubHeading03 = ({
  children,
  style,
  colorClassName,
  className,
}) => (
  <p
    className={`k-ds-subheading-03 m-0 ${className} ${colorClassName}`}
    style={{ ...style }}
  >
    {children}
  </p>
);

TextSubHeading03.propTypes = TextPropType.isRequired;
TextSubHeading03.defaultProps = textDefaultProps;

export const Spacing01 = () => <div className="k-ds-m-top-sp-01" />;
export const Spacing02 = () => <div className="k-ds-m-top-sp-02" />;
export const Spacing03 = () => <div className="k-ds-m-top-sp-03" />;
export const Spacing04 = () => <div className="k-ds-m-top-sp-04" />;
export const Spacing05 = () => <div className="k-ds-m-top-sp-05" />;
export const Spacing06 = () => <div className="k-ds-m-top-sp-06" />;
export const Spacing07 = () => <div className="k-ds-m-top-sp-07" />;
export const Spacing08 = () => <div className="k-ds-m-top-sp-08" />;
export const Spacing09 = () => <div className="k-ds-m-top-sp-09" />;

export const LayoutSpacing01 = () => <div className="k-ds-m-top-lyt-01" />;
export const LayoutSpacing02 = () => <div className="k-ds-m-top-lyt-02" />;
export const LayoutSpacing03 = () => <div className="k-ds-m-top-lyt-03" />;
export const LayoutSpacing04 = () => <div className="k-ds-m-top-lyt-04" />;
export const LayoutSpacing05 = () => <div className="k-ds-m-top-lyt-05" />;
export const LayoutSpacing06 = () => <div className="k-ds-m-top-lyt-06" />;
export const LayoutSpacing07 = () => <div className="k-ds-m-top-lyt-07" />;

export const ProgressBar = ({ now, fillBarColor }) => (
  <div className="k-ds-progress-bar background">
    <div
      className={`k-ds-progress-bar ${fillBarColor}`}
      style={{ width: `${now}%` }}
    />
  </div>
);

ProgressBar.propTypes = {
  now: PropTypes.number,
  fillBarColor: PropTypes.string,
};

ProgressBar.defaultProps = {
  now: 0,
  fillBarColor: 'k-ds-bg-color-light-green-500',
};

// TODO: Add proptypes definition
export const TwoColumnList = ({ data, separator }) => {
  const selectedSeparator = typeof separator === 'function' ? separator() : <Spacing05 />;

  const getData = (value) => {
    if (value && typeof value === 'string') {
      return value;
    }
    if (value && typeof value === 'function') {
      return value();
    }

    return null;
  };

  return (
    data.map((item, i) => {
      if (!item) return null;

      const leftData = getData(item.left);
      const rightData = getData(item.right);
      // TODO: Refactor custom component displaying rule.
      const leftCustomComponent = item && typeof item.left === 'function';
      const rightCustomComponent = item && typeof item.right === 'function';

      return (
        <div key={item.key}>
          {(i !== 0 && i < data.length) ? selectedSeparator : null}
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
            { leftCustomComponent
              ? leftData
              : (
                <PlatformWrapper
                  mainProps={{ colorClassName: 'k-ds-text-color-secondary' }}
                  desktop={TextBody02}
                  mobile={TextLabel01}
                >
                  {leftData}
                </PlatformWrapper>
              )
            }
            { rightCustomComponent
              ? rightData
              : (
                <PlatformWrapper
                  desktop={TextBody02}
                  mobile={TextLabel01}
                >
                  {rightData}
                </PlatformWrapper>
              )
            }
          </div>
        </div>
      );
    })
  );
};

export const inputStatus = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
};

export const IconContainer = ({
  size,
  color,
  children,
  onClick,
  label,
  style,
  className,
}) => {
  const containerStyle = {
    backgroundColor: color,
    placeContent: 'center',
    display: 'flex',
    alignItems: 'center',
    width: size,
    height: size,
    minWidth: size,
    minHeight: size,
    ...style,
  };

  if (!onClick) {
    return (
      <div className={className} style={containerStyle}>
        {children}
      </div>
    );
  }

  return (
    <div
      role="button"
      aria-label={label}
      tabIndex={0}
      onClick={onClick}
      onKeyPress={onClick}
      style={containerStyle}
      className={`cursor-pointer ${className}`}
    >
      {children}
    </div>
  );
};

IconContainer.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  children: PropTypes.oneOfType([PropTypes.object]).isRequired,
  label: PropTypes.string,
  style: PropTypes.oneOfType([PropTypes.object]),
  onClick: PropTypes.func,
  className: PropTypes.string,
};

IconContainer.defaultProps = {
  color: 'transparent',
  onClick: null,
  label: 'button',
  style: null,
  className: '',
};

export const WithIconRounded = (props) => {
  const {
    borderColor,
    borderWidth,
    children,
    className,
    containerColor,
    containerSize,
    onClick,
    padding,
    round,
  } = props;

  const getColor = () => (round ? containerColor : 'transparent');

  const getSize = () => {
    if (round) {
      return containerSize;
    }
    return 'fit-content';
  };

  const getStyles = () => {
    const styles = {};

    if (round) {
      styles.borderRadius = containerSize / 2;
    }

    if (borderColor && borderWidth) {
      styles.border = `${borderWidth}px solid ${borderColor}`;
    }

    if (padding) {
      styles.padding = `${padding}px`;
    }
    return styles;
  };

  return (
    <IconContainer
      color={getColor()}
      className={className}
      size={getSize()}
      onClick={onClick}
      style={getStyles()}
    >
      {children}
    </IconContainer>
  );
};

WithIconRounded.propTypes = {
  borderColor: PropTypes.string,
  borderWidth: PropTypes.number,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  containerColor: PropTypes.string,
  containerSize: PropTypes.number,
  onClick: PropTypes.func,
  padding: PropTypes.number,
  round: PropTypes.bool,
};

WithIconRounded.defaultProps = {
  borderColor: '',
  borderWidth: 1,
  className: '',
  containerColor: '#EBEEF7',
  containerSize: 32,
  onClick: null,
  padding: 0,
  round: false,
};

// TODO: Refactor styles
export const Pill = ({ text, onClick, style, status = inputStatus.INACTIVE }) => {
  const selectedClass = status === inputStatus.ACTIVE ? 'active' : 'inactive';

  return (
    <button
      className={`pill k-ds-heading-01 ${selectedClass}`}
      onClick={onClick}
      style={{ ...style }}
      type="button"
    >
      {text}
    </button>
  );
};

Pill.propTypes = {
  onClick: PropTypes.func,
  status: PropTypes.string,
  style: PropTypes.oneOfType([PropTypes.object]),
  text: PropTypes.string.isRequired,
};

Pill.defaultProps = {
  onClick: () => {},
  status: inputStatus.INACTIVE,
  style: {},
};

export const Tag = ({ children, backgroundColor, textColor }) => (
  <div
    className={`${backgroundColor}`}
    style={{ borderRadius: 8, padding: '4px 8px' }}
  >
    <TextLabel01
      colorClassName={textColor}
      style={{ textTransform: 'uppercase' }}
    >
      {children}
    </TextLabel01>
  </div>
);

Tag.propTypes = {
  children: PropTypes.node.isRequired,
  backgroundColor: PropTypes.string,
  textColor: PropTypes.string,
};

Tag.defaultProps = {
  backgroundColor: 'k-ds-bg-color-red-100',
  textColor: 'k-ds-text-color-red-900',
};

export const Badge = ({
  backgroundColor,
  borderColor,
  children,
  className,
  fullWidth,
  textAlign,
  textColor,
  withBorder,
}) => (
  <div
    className={className}
    style={{
      backgroundColor,
      borderColor,
      borderRadius: 8,
      borderStyle: withBorder ? 'solid' : 'none',
      borderWidth: withBorder ? '1px' : '0',
      display: fullWidth ? 'block' : 'inline-flex',
      padding: '4px 8px',
    }}
  >
    <TextLabel01
      style={{
        color: textColor,
        textTransform: 'uppercase',
        textAlign,
      }}
    >
      {children}
    </TextLabel01>
  </div>
);

Badge.propTypes = {
  backgroundColor: PropTypes.string,
  borderColor: PropTypes.string,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  fullWidth: PropTypes.bool,
  textAlign: PropTypes.string,
  textColor: PropTypes.string,
  withBorder: PropTypes.bool,
};

Badge.defaultProps = {
  backgroundColor: '#BDBDBD',
  borderColor: '#2E2E2E',
  className: '',
  fullWidth: false,
  textAlign: 'left',
  textColor: '#151515',
  withBorder: true,
};

export const List = ({
  data, renderItem, separator, withFirstSeparator, withLastSeparator,
}) => {
  const selectedSeparator = separator || <div className="m-top-16" />;
  const history = useHistory();

  if (!data) return null;

  return (
    <div className="flex-column">
      {data.map((dataItem, index) => (
        <div key={dataItem.id ?? index}>
          {index === 0 && withFirstSeparator ? selectedSeparator : null}
          {renderItem(dataItem, {
            history,
          })}
          {index === data.length - 1 && !withLastSeparator ? null : selectedSeparator}
        </div>
      ))}
    </div>
  );
};

List.propTypes = {
  renderItem: PropTypes.func.isRequired,
  data: PropTypes.arrayOf(PropTypes.object),
  separator: PropTypes.element,
  withFirstSeparator: PropTypes.bool,
  withLastSeparator: PropTypes.bool,
};

List.defaultProps = {
  data: null,
  separator: null,
  withFirstSeparator: true,
  withLastSeparator: true,
};

// TODO: Refactor platform behavior to use only one className
export const Card = ({ children, className, mobileClassName }) => {
  const isMobile = useMobileMediaQuery();

  return (
    <div className={`card ${isMobile ? mobileClassName : className}`}>
      {children}
    </div>
  );
};

Card.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  mobileClassName: PropTypes.string,
};

Card.defaultProps = {
  className: '',
  mobileClassName: '',
};

export const LinkButton = ({ text, onClick, style }) => (
  <button className="k-ds-heading-01 link" onClick={onClick} type="button" style={style}>
    <b>{text}</b>
  </button>
);

LinkButton.propTypes = {
  text: PropTypes.node.isRequired,
  style: PropTypes.oneOfType([PropTypes.object]),
  onClick: PropTypes.func,
};

LinkButton.defaultProps = {
  onClick: () => {},
  style: {},
};

export const buttonSizeType = Object.freeze({
  SMALL: 'small',
  LARGE: 'large',
});

export const buttonType = Object.freeze({
  GHOST: 'ghost',
  LINK: 'link',
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  SIMPLE: 'simple',
});

export const Button = React.forwardRef(({
  disabled, fullWidth, children, size, type, onClick, padding, ...props
}, ref) => {
  let className = type === buttonType.PRIMARY ? 'k-ds-bg-interactive-primary' : null;

  if (disabled) {
    className = 'k-ds-bg-interactive-disabled';
  }

  return (
    <DesignButton
      ref={ref}
      disabled={disabled}
      type={type}
      className={className}
      size={size}
      onClick={onClick}
      style={{ width: fullWidth ? '100%' : 'auto', padding }}
      {...props}
    >
      {children}
    </DesignButton>
  );
});

Button.propTypes = {
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
  padding: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onClick: PropTypes.func,
  size: PropTypes.oneOf(Object.values(buttonSizeType)),
  type: PropTypes.oneOf(Object.values(buttonType)),
};

Button.defaultProps = {
  disabled: false,
  fullWidth: false,
  padding: null,
  onClick: () => {},
  size: buttonSizeType.LARGE,
  type: buttonType.PRIMARY,
};

export const BoxContainer = ({ bgColorClassName, children, onClick, dataTestId }) => {
  if (onClick) {
    return (
      <div
        role="button"
        className={`k-ds-box-container cursor-pointer ${bgColorClassName}`}
        onClick={onClick}
        onKeyPress={onClick}
        tabIndex={0}
        data-testid={dataTestId}
      >
        {children}
      </div>
    );
  }

  return <div className={`k-ds-box-container ${bgColorClassName}`}>{children}</div>;
};

BoxContainer.propTypes = {
  bgColorClassName: PropTypes.string,
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
};

BoxContainer.defaultProps = {
  onClick: null,
};
BoxContainer.defaultProps = {
  bgColorClassName: 'k-ds-bg-color-light-grey-300',
};

export const NumberMXNInput = ({
  errorMessage,
  helper,
  label,
  max,
  onChange,
  placeholder,
  value,
  id,
  onFocus,
  onBlur,
  name,
  truncate,
}) => {
  const [focused, setFocused] = useState(false);
  const [hasError, setHasError] = useState(max < value);
  const [inputValue, setInputValue] = useState(value ? value.toString() : '');

  const removeDecimals = (strNumber) => (
    strNumber?.replace(/\.\d*$/, '') ?? strNumber
  );

  useEffect(() => {
    const currentValue = inputValue?.toString() ?? '';

    let newInputValue = focused
      ? currentValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      : formatNumberToMX(parseMXToNumber(currentValue))
    newInputValue = newInputValue || '';
    if (truncate) newInputValue = removeDecimals(newInputValue);

    setInputValue(newInputValue);
  }, [value, inputValue, focused, truncate]);

  const handleAmountChange = (event) => {
    const newValue = event.target.value;

    let strValue = newValue.replace(/[^\d.]/g, '');
    const numArr = strValue.split('.');

    if (numArr.length === 3) {
      strValue = strValue.trimEnd('.');
    }

    if (numArr.length === 2 && numArr[1].length > 2) {
      return;
    }

    if (truncate) strValue = removeDecimals(strValue);;

    setInputValue(strValue);
    const v = parseMXToNumber(strValue);
    setHasError(max < v);
    onChange(v);
  };

  const handleOnBlur = useCallback((event) => {
    setFocused(false);
    onBlur(event);
  }, [onBlur]);

  const handleOnFocus = useCallback((event) => {
    setFocused(true)
    onFocus(event);
  }, [onFocus]);

  const currentErrorMessage = hasError ? 'El monto no es válido' : errorMessage;
  
  return (
    <DesignTextInput
      onChange={handleAmountChange}
      type="line"
      value={inputValue ?? ''}
      errorMessage={currentErrorMessage}
      onBlur={handleOnBlur}
      onFocus={handleOnFocus}
      placeholder={placeholder}
      label={label}
      helper={helper}
      id={id}
      name={name}
    />
  );
};

NumberMXNInput.propTypes = {
  max: PropTypes.number,
  onChange: PropTypes.func,
  errorMessage: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  placeholder: PropTypes.string,
  label: PropTypes.string,
  helper: PropTypes.string,
  id: PropTypes.string,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  name: PropTypes.string,
  truncate: PropTypes.bool,
};

NumberMXNInput.defaultProps = {
  max: Number.MAX_VALUE,
  onChange: () => {},
  errorMessage: null,
  value: null,
  placeholder: null,
  label: null,
  helper: null,
  id: null,
  onFocus: () => {},
  onBlur: () => {},
  name: null,
  truncate: false,
};

export const Anchor = styled.a`
  color: var(--k-ds-color-interactive-primary-active);
  cursor: pointer;
  text-decoration: none !important;
`;
